import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import ComponentTitleAndSousTitle from "../../layout/ComponentTitleAndSousTitle";
import { apiGetVisualmanagements } from "../../../api/ApiVisualmanagement";

const ComponentVisualManagement = () => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const [state, setState] = useState([]);

  const recupDatas = async () => {
    const res = await apiGetVisualmanagements(ReduxInstance._id);
    if (res.data[0]) setState(res.data[0]);
    else setState([]);
  };

  useEffect(() => {
    recupDatas();
  }, [ReduxInstance]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      {ReduxInstance.modulesActives.includes("visualmanagement") && state.url && (
        <>
          <ComponentTitleAndSousTitle title={t("public.pageHome.titleBloc5")} />
          <div style={{ height: 220, width: 340 }}>
            <iframe src={state.url} width="100%" height="220px" scrolling="no" title="vm"></iframe>
          </div>
        </>
      )}
    </>
  );
};

export default ComponentVisualManagement;
